import {
  Typography,
  Box,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const UnknownDialog=({unknownRetryAttempted}) => {
  const theme=createTheme({
    typography: {
      fontSize: 20,
      h6: {
        fontSize: 20,
        "@media (min-width:600px)": {
          fontSize: 35,
        },
        "@media (min-width:960px)": {
          fontSize: 26,
        },
      },
      body1: {
        fontSize: 18,
        "@media (min-width:600px)": {
          fontSize: 26,
        },
        "@media (min-width:960px)": {
          fontSize: 20,
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "40px 0px",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <ErrorIcon
            sx={{color: "#d32f2f",fontSize: {xs: 45,sm: 60,md: 55}}}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#d32f2f",
            }}
          >
            Employee is unknown.
          </Typography>
        </Box>

        <Box
          sx={{
            width: {xs: "90%",sm: "80%"},
            margin: "auto",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#555",
              fontWeight: 500,
              lineHeight: 1.5,
            }}
          >
            {!unknownRetryAttempted? "Retrying once again...":"Retry again to mark your attendance"}
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default UnknownDialog;
